import { VContainer } from 'vuetify/lib/components/VGrid';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';

var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.escuelaTienePermiso)?_c(VContainer,[_c(VSkeletonLoader,{attrs:{"type":"list-item-two-line@5"}})],1):_c(VContainer,[(_vm.app == 'campus')?_c('tabsCursosComponent'):_c('listadoPlantillasComponent')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }